const updateProductTabBarState = (productTabBar) => {
    const state = window.scrollY >= productTabBar.offsetTop;
    const deviceInfoSummary = productTabBar.querySelector('.deviceinfoSummary');

    deviceInfoSummary.classList.toggle('sticky', state);

    productTabBar.style.paddingTop = state ?
        `${deviceInfoSummary.offsetHeight}px` : '0';
};

const stickyTabBar = () => {
    const productTabBar = document.querySelector('[data-tab-bar]');

    if (!productTabBar) {
        return;
    }

    const init = () => updateProductTabBarState(productTabBar);

    window.addEventListener('scroll', init);
    window.addEventListener('resize', init);
    init();
};

export default stickyTabBar;
